<script>
  import { onMount } from "svelte"
  import { navigate } from "../utils/index"

  onMount(() => {
    navigate("/users")
  })
</script>
